
export const getNormalisedRandomValue = (min : number, max : number) => {
    const seed = 2.0 * (Math.random()-0.5);
    const n =  Math.acos(seed) / Math.PI; 
    return min + (max - min) * n;
}